import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RUTA_API_USUARIOS } from '../Contantes/Constantes';
import { IconButton, InputAdornment, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const searchParams = new URLSearchParams(document.location.search);

export default function SolicitudActiveDirectory({ ...props }) {
    const [uuid, setUuid] = useState(null);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' o 'error'
    const [solicitudExists, setSolicitudExists] = useState(true);

    useEffect(() => {
        const uuid_url = searchParams.get('uuid');
        if (uuid_url) {
            const verifyUuid = async () => {
                const isValid = await checkUuidSolicitudAD(uuid_url);
                setUuid(uuid_url);
                setSolicitudExists(isValid);
            };
            verifyUuid();
        }
    }, []);

    const checkUuidSolicitudAD = async (uuid) => {
        try {
            const response = await axios.get(`${RUTA_API_USUARIOS}/activedirectory/solicitudAD/${uuid}`);
            return response.data;
        } catch (error) {
            console.error('Error al verificar el UUID:', error);
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${RUTA_API_USUARIOS}/activedirectory/${username}`, {
                uuid,
                username,
                password,
            });
            if (response.status === 200) {
                setMessage(response.data.message || 'Usuario agregado correctamente');
                setMessageType('success');
            } else {
                setMessage('Error en el envío');
                setMessageType('error');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Hubo un error al querer activar el usuario');
            setMessageType('error');
        }
    };

    const toggleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <div>
            {!solicitudExists ? (
                <p style={{ color: 'red', textAlign: 'center' }}>No existe solicitud para este usuario.</p>
            ) : (
                <form
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        maxWidth: '400px',
                        margin: '0 auto',
                        padding: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        backgroundColor: '#f9f9f9',
                    }}
                    onSubmit={handleSubmit}
                >
                    <FormControl variant="outlined" style={{ marginBottom: '15px' }} fullWidth>
                        <InputLabel htmlFor="username">Usuario</InputLabel>
                        <OutlinedInput
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            label="Usuario"
                            required
                        />
                    </FormControl>

                    <FormControl variant="outlined" style={{ marginBottom: '15px' }} fullWidth>
                        <InputLabel htmlFor="password">Contraseña</InputLabel>
                        <OutlinedInput
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            label="Contraseña"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={toggleShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            required
                        />
                    </FormControl>

                    {message && (
                        <p
                            style={{
                                color: messageType === 'success' ? 'green' : 'red',
                                marginTop: '10px',
                                textAlign: 'center',
                            }}
                        >
                            {message}
                        </p>
                    )}

                    {message !== 'Usuario agregado correctamente' && (
                        <button
                            style={{
                                padding: '10px',
                                backgroundColor: '#B71234',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                            }}
                            type="submit"
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#9F0F2B')}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#B71234')}
                        >
                            Enviar
                        </button>
                    )}
                </form>
            )}
        </div>
    );
}
